import { useTranslation } from "react-i18next";
import { kmcMarketList, MarketLeftNavsList } from "../utils/constants";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { RenderNavItem } from "../components/RenderNavItem";

const KMC_market_list = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />
        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
          <div className="container">
            <div className="section-main-heading2">
              <h4 className="fontSizeClass"> </h4>
            </div>
          </div>
        </div>
      </section>
      <section className="section inner-pad1">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu  min-height-400">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {MarketLeftNavsList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="inner-title2">
                <h3 className="fontSizeClass"> {t("KMC Market List")} </h3>
              </div>
              <div className="mayor-table">
                <table className="table table-bordered">
                  <thead>
                    <tr className="table-warning table-bor-2">
                      <th className="bd-wid" scope="col">
                        {t("Sl No")}
                      </th>
                      <th scope="col"> {t("Name")} </th>
                      <th scope="col"> {t("Address")} </th>
                      <th scope="col"> {t("Pin Code")} </th>
                      <th scope="col"> {t("Phone")} </th>
                      <th scope="col"> {t("Stallage Fee")} </th>
                    </tr>
                  </thead>
                  <tbody>
                    {kmcMarketList.map((item, index) => (
                      <tr>
                        <td> {item.slNo} </td>
                        <td> {t(item.name)} </td>
                        <td>{t(item.address)}</td>
                        <td>{t(item.pinCode)}</td>
                        <td>{t(item.phone)}</td>
                        <td>
                          <button
                            className="btn btn-primary btn-right btn-1"
                            data-toggle="modal"
                            data-target={`#${item.modalId}`}
                          >
                            {t("View Fees")}
                          </button>
                          <div className="modal" id={item.modalId}>
                            <div className="modal-dialog modal-dialog-scrollable">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h4 className="modal-title">
                                    {t(item.title)}
                                  </h4>
                                  <button
                                    type="button"
                                    className="btn-close"
                                    data-dismiss="modal"
                                  >
                                    &times;
                                  </button>
                                </div>

                                <div className="modal-body">
                                  <h3 className="fontSizeClass">
                                    {t(item.header)}..
                                  </h3>
                                  <p className="fontSizeClass">
                                    {t(item.para)}
                                  </p>
                                </div>

                                <div className="modal-footer">
                                  <button
                                    type="button"
                                    className="btn btn-danger"
                                    data-dismiss="modal"
                                  >
                                    {t("Close")}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default KMC_market_list;
